// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__13AmD","footer":"ChangeClinic_footer__3n6x8"};